import gql from "graphql-tag"
import MediaRevisionFragment from "../fragment/MediaRevisionFragment"

export default gql`
  ${MediaRevisionFragment}
  mutation mediaRevisionActivate($revisionId: String!) {
    revision: mediaRevisionActivate(revisionId: $revisionId) {
      ...MediaRevisionFragment
    }
  }
`
